import CancelIcon from '@mui/icons-material/Cancel';
import { Stepper, Step, StepLabel, StepIcon } from '@mui/material';
import { StepProgress } from '../../rtk/settingsActivityTypes';
import './stepperBar.scss';

type Props = {
  stepProgress: StepProgress;
  className?: string;
};

export default function StepperBar({ stepProgress, className }: Props) {
  const { activeStep, failStep, steps } = stepProgress;

  const getStepIconTestId = (stepIndex: number) => {
    if (failStep === stepIndex) {
      return 'CancelIcon';
    }

    if (activeStep >= stepIndex) {
      return 'CheckCircleIcon';
    }

    return 'EmptyStateIcon';
  };

  return (
    <Stepper
      className={`stepper-bar ${className || ''}`}
      alternativeLabel
      activeStep={activeStep}
    >
      {steps.map((label, index) => (
        <Step key={label}>
          {failStep === index ? (
            <StepLabel
              color="error"
              error
              slots={{
                stepIcon: (props) => (
                  <CancelIcon
                    className={props.className}
                    sx={props.sx}
                    data-testid={getStepIconTestId(index)}
                  />
                ),
              }}
            >
              {label}
            </StepLabel>
          ) : (
            <StepLabel
              slots={{
                stepIcon: (props) => (
                  <StepIcon {...props} data-testid={getStepIconTestId(index)} />
                ),
              }}
            >
              {label}
            </StepLabel>
          )}
        </Step>
      ))}
    </Stepper>
  );
}
